export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-05-29 at 00.42.30.f8d5bb2c.jpeg";